import { render } from "./InnovationProjectPage.vue?vue&type=template&id=a884089e&scoped=true"
import script from "./InnovationProjectPage.vue?vue&type=script&lang=js"
export * from "./InnovationProjectPage.vue?vue&type=script&lang=js"

import "./InnovationProjectPage.vue?vue&type=style&index=0&id=a884089e&lang=scss&scoped=true"
import "./InnovationProjectPage.vue?vue&type=style&index=1&id=a884089e&lang=scss"
import "./InnovationProjectPage.vue?vue&type=style&index=2&id=a884089e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a884089e"]])

export default __exports__